export class File360Error {

    public static ERR_UNHANDLED = 0;

    private _id: number = 0;
    private _message: string = "";
    private _err: Error = new Error();

    // Constructor
    constructor(id: number, message: string, err: Error) {
        if (!err) {
            this.Err = new Error(message);
        }
        else {
            this.Err = err;
        }
        this.Id = id;
        this.Message = message;
    }

    /**
     * Getter id
     * @return {number}
     */
    public get Id(): number {
        return this._id;
    }

    /**
     * Setter id
     * @param {number} value
     */
    public set Id(value: number) {
        this._id = value;
    }

    /**
     * Getter message
     * @return {string}
     */
    public get Message(): string {
        return this._message;
    }

    /**
     * Setter message
     * @param {string} value
     */
    public set Message(value: string) {
        this._message = value;
    }


    /**
     * Getter err
     * @return {Error}
     */
    public get Err(): Error {
        return this._err;
    }

    /**
     * Setter err
     * @param {Error} value
     */
    public set Err(value: Error) {
        this._err = value;
    }

}